import PrimaryDialogButton from './PrimaryDialogButton';
export default PrimaryDialogButton;